import AnalyticsApi from '../AnalyticsApi';
import standardInsightsEvents from './standardInsightsEvents';

/**
 * Creates and returns {@link EventReporter}s for the set of standard Insights events.
 */
export default (analytics: AnalyticsApi) =>
  Object.freeze({
    reportAddToCart: standardInsightsEvents.addToCart.reporter(analytics),
    reportAddToWishlist: standardInsightsEvents.addToWishlist.reporter(analytics),
    reportInitPlanningSession: standardInsightsEvents.initPlanningSession.reporter(analytics),
    reportSaveDesign: standardInsightsEvents.saveDesign.reporter(analytics),
    reportVpcInteraction: standardInsightsEvents.vpcInteraction.reporter(analytics)
  });
